<div class="seccion">
  <div class="cabecera">
    <p class="ayuda">
      Botones que se muestran en "Servicios o Trámites" (menú "Más" de la app
      nativa). El orden acá abajo es el orden en que aparecen.
    </p>
    <button mat-stroked-button type="button" (click)="agregar()">
      <mat-icon>add</mat-icon>
      Agregar botón
    </button>
  </div>

  <div
    cdkDropList
    [cdkDropListData]="ids"
    (cdkDropListDropped)="drop($event)"
    class="dropzone"
  >
    @for (id of ids; track id; let i = $index) {
      <div class="chip" cdkDrag>
        <mat-icon cdkDragHandle>drag_indicator</mat-icon>
        <span class="nombre">{{ etiqueta(id) }}</span>
        <button
          mat-icon-button
          type="button"
          matTooltip="Quitar"
          (click)="quitar(i)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    } @empty {
      <div class="vacio">
        Sin botones todavía: la sección no se muestra en la app hasta que
        agregues al menos uno.
      </div>
    }
  </div>
</div>
